export default "__VITE_ASSET__Dk0D_Cyz__"